import React from "react";
import PropTypes from "prop-types";
import SbEditable from "storyblok-react";
import Video from "~components/molecules/video/video/video";
import { MEDIA } from "../../../prop_types";
import { captionStyle, captionVideoStyle } from "./caption_video.module.scss";

export default function CaptionVideo({ video: [video], caption, ...rest }) {
  if (video) {
    return (
      <SbEditable content={rest}>
        <div className={captionVideoStyle}>
          <Video {...video} />
          {caption && <p className={captionStyle}>{caption}</p>}
        </div>
      </SbEditable>
    );
  }

  return null;
}

CaptionVideo.defaultProps = {
  video: null,
  caption: "",
};

CaptionVideo.propTypes = {
  video: MEDIA,
  caption: PropTypes.string,
};
